<template>
  <el-row type="flex" justify="space-between" style="padding-left: 30px;padding-bottom: 10px">
    <el-row type="flex">
      <slot></slot>
    </el-row>
    <el-row type="flex">
      <slot name="right"></slot>
    </el-row>
  </el-row>
</template>
<script>
  export default {
    props: {},
    data () {
      return {}
    },
    computed: {},
    watch: {},
    mounted () {
    },
    methods: {}
  }
</script>
<style lang="scss" scoped>
</style>
